module.exports = __webpack_public_path__ + "img/meter-on-green.3ef354ff.svg";